export default __webpack_public_path__ + "static/media/Split_Leg_Position_Femal.ceb6d92f.png";